import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BusService } from '@app/shared/services/bus.service';
import { NGXLogger } from 'ngx-logger';
import { filter, first } from 'rxjs/operators';
import { MapComponent } from '../map/map.component';
import { MENU_ITEMS } from './menu.config';
import { animate, sequence, state, style, transition, trigger } from '@angular/animations';
import { NoticesService } from '@app/shared/services/notices.service';
import { Notice } from '@app/shared/models/notices.model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'ty-menu',
  templateUrl: './menu.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./menu.component.scss'],
  animations: [
    trigger('iconState', [
      state('inactive', style({
      })),
      transition('* => active',
        sequence([
          animate('200ms ease-in', style({transform: 'rotate(30deg)'})),
          animate('200ms ease-out', style({transform: 'rotate(-60deg)'})),
          animate('200ms ease-in', style({transform: 'rotate(30deg)'}))
        ])
      )
    ])
  ]
})
export class MenuComponent implements OnInit {
  iconState: string = 'inactive';
  notices!: Notice[];

  readonly items = MENU_ITEMS;

  routeActive = '/';

  constructor(
    private logger: NGXLogger,
    private router: Router,
    public busService: BusService,
    public mapComponent: MapComponent,
    private noticesService: NoticesService,
    private snackBar: MatSnackBar
  ) {
    // this.addCustomIcons();
  }

  toggleState() {
    this.iconState = 'active';
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const routes = this.router.url.split('/').slice(1).filter(x => !x.includes(this.busService.simulatePath));
      this.routeActive = '/' + routes.join('');
    }, (error) => this.logger.error(error));
    // TODO: PARA LAS NOTICIAS
    // this.getNotices();
  }

  getNotices(): void{
    this.noticesService.getNotices().pipe(first()).subscribe((res: Notice[]) => {
      this.notices = res;
      if ( this.notices.length != 0) {
        // this.snackBar.open('Hay avisos nuevos', 'Aceptar', {duration: 5000});
        this.toggleState();
      } else {
        return
      }
    },
      (err) => {
        this.snackBar.open('No se ha podido comprobar los avisos', 'Aceptar', {duration: 5000});
        this.logger.error(`Error al cargar los avisos en: buscomponent.ts ${err.message}`);
      });
  }

  navigateToSimulatedPath(link?: string) {
    if (!link) {
      return;
    }

    if (this.router.url.includes(this.busService.simulatePath)) {
      this.router.navigate([`/${this.busService.simulatePath}/${link}`]);
    } else {
      this.router.navigate([link]);
    }
  }
}
